import { createUseStyles, Styles } from '@pff-consumer/tweed-ui/web-styles'

interface CheckoutSummaryStyles {
  container: Styles
  checkoutSummaryRow: Styles
  finalPriceContainer: Styles
  coupon: Styles
}

export const useStyles = createUseStyles<CheckoutSummaryStyles>((theme) => {
  return {
    container: {
      width: '100%',
      marginBottom: theme.calcUnit(theme.spacing.s2),
    },
    checkoutSummaryRow: {
      display: 'flex',
      flexDirection: 'row',
      alignItems: 'center',
      justifyContent: 'space-between',
      width: '100%',
      paddingInline: theme.calcUnit(theme.spacing.s2),
      marginTop: theme.calcUnit(theme.spacing.s3),
    },
    finalPriceContainer: {
      paddingTop: theme.calcUnit(theme.spacing.s1),
      paddingBottom: theme.calcUnit(theme.spacing.s1),
      marginBottom: theme.calcUnit(theme.spacing.s4),
      backgroundColor: theme.colors.webFadedBackground,
      borderRadius: theme.calcUnit(theme.borderRadius.roundedSm),
    },
    coupon: {
      display: 'inline-flex',
      backgroundColor: theme.colors.subscriptionCouponTextColor,
      paddingBlock: theme.calcUnit(theme.spacing.s1),
      paddingInline: theme.calcUnit(theme.spacing.s2),
      borderRadius: theme.calcUnit(theme.borderRadius.roundedFull),
      marginLeft: theme.calcUnit(theme.spacing.s2),
      textTransform: 'uppercase',
    },
  }
})
